import { useAuth0 } from "@auth0/auth0-react";
import { useFormik } from "formik";
import React, { useEffect, useLayoutEffect, useState } from "react";
import { toastr } from "react-redux-toastr";
import { useLocation } from "react-router-dom";
import FinanceSettingService from "../../../../Lib/API/FinanceSetting/FinanceSetting";
import NotAuthorized from "../../../../components/NotAuthorized";
import SettingHeader from "../../SettingHeader/settingHEader";
import ComponentHeading from "../../componentHeading/ComponentHeading";
import LeftMenu from "../../leftMenu/LeftMenu";
const ReversalTypes = ({ heading }) => {
  const [typeID, setTypeID] = useState("");
  const [type, setType] = useState("");
  const [disableAddNew, setDaisableAddNew] = useState();
  const [disable, setDisable] = useState(false);
  const [addNew, setAddNew] = useState(false);
  const [edit, setEdit] = useState(false);
  const [addPath, setAddPath] = useState("");
  const { getAccessTokenSilently } = useAuth0();
  const [reversalTypes, setReversaltypes] = useState([]);
  const [reversaldata, setReversalData] = useState({});
  const [IsSettingsActive, setIsSettingsActive] = useState(true);
  const { pathname } = useLocation();
  // formik values
  const formik = useFormik({
    enableReinitialize: true,
    initialValues:
      addNew === true
        ? {
            reversal_applicable_charge: true,
            reversal_applicable_payment: true,
            reversal_types_input: "",
            reversal_hidden_statement: false,
            reversal_gateway_refund: false, 

          }
        : {
            reversal_applicable_charge: reversaldata?.applicable_charge ?? true,
            reversal_applicable_payment:
              reversaldata?.applicable_payment ?? true,
            reversal_types_input:
              reversaldata?.type ?? reversalTypes[0]?.type ?? "",
            reversal_hidden_statement: reversaldata?.hidden ?? false,
            reversal_gateway_refund: reversaldata?.doNotGatewayRefund ?? false,
          },
  });
  const initialValues = () => {
    formik.setFieldValue("reversal_applicable_charge", "");
    formik.setFieldValue("reversal_applicable_payment", "");
    formik.setFieldValue("reversal_types_input", "");
    formik.setFieldValue("reversal_hidden_statement", "");
    formik.setFieldValue("reversal_gateway_refund", "");
  };
  // Get All Revrsal Types
  const fetchReversalTypes = async (id) => {
    const token = await getAccessTokenSilently();
    await FinanceSettingService.getReversalTypes(id, token).then((res) => {
      setReversaltypes(res?.result);
      setType(res?.result[0]?.type);
      getReversalDataById(res?.result[0]?.type,res?.result[0]?._id)
    });
  };
  // Get Revrsal By Id
  const getReversalDataById = async (type, id) => {
    setType(type);
    setTypeID(id);
    const token = await getAccessTokenSilently();
    await FinanceSettingService.getReversalTypesById(id, token).then((res) =>
      setReversalData(res.result)
    );
  };
  // update Revrsal
  const updateReversal = async () => {
    if (
      formik.values?.reversal_types_input == "" ||
      !formik.values?.reversal_types_input.match(
        /^(?![\s-])[\w\s-]+$/,
        "Enter a valid name"
      )
    ) {
      toastr.error("error", "Please enter a valid Reversal Types");
    } else {
      const token = await getAccessTokenSilently();
      await FinanceSettingService.updateReversalById(
        typeID,
        {
          type: formik.values?.reversal_types_input,

          applicable_charge: formik.values?.reversal_applicable_charge,

          applicable_payment: formik.values?.reversal_applicable_payment,

          hidden: formik.values?.reversal_hidden_statement,

          doNotGatewayRefund: formik?.values?.reversal_gateway_refund,
        },
        token
      )
        .then(() => toastr.success("Success", "Revesal Type has been updated"))
        .catch((error) => {
          toastr.error(
            "Update Error",
            error?.data?.message ?? "Some fields are missing"
          );
        });
    }
    // fetchReversalTypes();
       const currentId = typeID;

  // Refetch list
  const token2 = await getAccessTokenSilently();
  const res = await FinanceSettingService.getReversalTypes(undefined, token2);

  setReversaltypes(res?.result);

  // Find the updated item in new list
  const updatedItem = res?.result?.find(
    (item) => item._id === currentId
  );

  if (updatedItem) {
    setType(updatedItem.type);
    setTypeID(updatedItem._id);

    // Fetch its latest data
    const res2 = await FinanceSettingService.getReversalTypesById(
      updatedItem._id,
      token2
    );

    setReversalData(res2.result);
  };}
  // Disable A Reversal
  const deleteReversalType = async () => {
    const token = await getAccessTokenSilently();
    await FinanceSettingService.deleteReversalById(
      token,
      typeID || reversalTypes[0]._id
    ).then((res) => {
      fetchReversalTypes();
      initialValues();
    });
  };

  // Create A New Reversal Type
  const createReversalType = async () => {
    if (
      formik.values?.reversal_types_input == "" ||
      !formik.values?.reversal_types_input.match(
        /^(?![\s-])[\w\s-]+$/,
        "Enter a valid name"
      )
    ) {
      toastr.error("error", "Please enter a valid Reversal Types");
    } else {
      const token = await getAccessTokenSilently();
      await FinanceSettingService.createNewReversalType(
        {
          type: formik.values?.reversal_types_input,
          applicable_charge: formik.values?.reversal_applicable_charge,
          applicable_payment: formik.values?.reversal_applicable_payment,
          hidden: formik.values?.reversal_hidden_statement,
          doNotGatewayRefund: formik?.values?.reversal_gateway_refund,
        },
        token
      )
        .then(() => {
          toastr.success("Success", "New Account has been created");
        })
        .catch((e) => {
          toastr.error(e?.data?.message ?? "Error");
        });
    }
    fetchReversalTypes();
  };
  useEffect(() => {
    fetchReversalTypes();
  }, []);
  useEffect(() => {
    if (pathname.includes("view")) {
      setEdit(false);
      setDaisableAddNew(false);
      setDisable(false);
      setAddNew(false);
    }
  }, [pathname]);

  let orgInfo =
    localStorage.getItem("authorizedModules") !== undefined
      ? JSON.parse(localStorage.getItem("authorizedModules"))
      : [];

  useEffect(() => {
    let check = orgInfo?.map((item) => {
      if (item?.moduleName == "financial setting") {
        return setIsSettingsActive(item?.active);
      }
    });
  }, []);

  return IsSettingsActive == false ? (
    <NotAuthorized title={"Reversal Types"} />
  ) : (
    <div className="w-100">
      <SettingHeader
        heading={heading}
        edit={edit}
        addNew={addNew}
        path={"/financial-setting/reversal-types/view"}
        setAddNew={setAddNew}
        parentHeading={"Financial"}
        alertOnEdit={edit}
      />
      <div className="setting-main main-setting__wrapper">
        <div className="left-menu-div">
          <LeftMenu
            heading={heading}
            getTypeId={getReversalDataById}
            types={reversalTypes}
            btnText={"New Reversal Type"}
            disableAddNew={disableAddNew}
            setAddNew={setAddNew}
            setDisable={setDisable}
            setDaisableAddNew={setDaisableAddNew}
            addPath={addPath}
          />
        </div>
        <div className="settings-details">
          <ComponentHeading
            type={formik.values?.reversal_types_input}
            heading={heading}
            addNew={addNew}
            disable={disable}
            setDaisableAddNew={setDaisableAddNew}
            setDisable={setDisable}
            edit={edit}
            setEdit={setEdit}
            setAddPath={setAddPath}
            reversaldata={reversaldata}
            updateFunc={updateReversal}
            formik={formik}
            createFunc={createReversalType}
            setAddNew={setAddNew}
            deleteFunc={deleteReversalType}
            addPath={addPath}
          />
        </div>
      </div>
    </div>
  );
};

export default ReversalTypes;
